// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhm_ss","PhotoTitleEditForm__cancelBtn":"iy_b bhm_sw bhm_sv"};